import { createContext, useContext } from 'react';

import { Store, createStore } from '../../../core/store/store.js';
import { TreeMapState } from '../types/state.js';

export const initialTreeMapState: TreeMapState = {
  groupsSelected: [],
  highlightedItem: undefined,
  overlay: {
    toolbarVisible: false,
  },
  hierarchyLeafNodes: [],
  hierarchyClusterNodes: [],
  colorMap: new Map(),
};

export const TreeMapStateContext = createContext<Store<TreeMapState>>(
  createStore<TreeMapState>(initialTreeMapState),
);

export const useSetState = () => {
  const { setState } = useContext(TreeMapStateContext);

  return setState;
};
